import pcssCommon from '../src/Common/pcss/*.pcss';
import pcssFrontend from '../src/Frontend/pcss/*.pcss';

import jsCommon from '../src/Common/js/*.js';
import jsFrontend from '../src/Frontend/js/*.js';